/* ============================================================
   skinmade — Quick Add to Cart auf Product Cards
   - Variant-Selector aktualisiert ATC-Button-Variant-ID
   - Locked-CTA öffnet Login-Modal mit Return-URL zur PDP
   - ATC dispatcht theme:cartchanged → Symmetry öffnet Drawer
   ============================================================ */

(function () {
  'use strict';

  function init() {
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches('[data-card-variant-select]')) {
        var card = e.target.closest('.sm-card-actions');
        if (!card) return;
        var atcBtn = card.querySelector('.sm-card-quick-add');
        if (atcBtn) {
          atcBtn.dataset.variantId = e.target.value;
          // Reset disabled-state for new variant (basic — könnte ausverkauft sein)
          var isDisabled = e.target.options[e.target.selectedIndex].disabled;
          atcBtn.disabled = isDisabled;
        }
      }
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.sm-card-quick-add');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        quickAdd(btn);
        return;
      }

      var lock = e.target.closest('.sm-card-btn--locked');
      if (lock) {
        e.preventDefault();
        e.stopPropagation();
        SmLogin.openModal({
          message: 'Dieses Produkt ist personalisiert. Logge dich kurz mit deiner Hautanalyse ein, dann kannst du es bestellen.',
          returnUrl: lock.dataset.productUrl
        });
      }
    });
  }

  function quickAdd(btn) {
    if (btn.disabled) return;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var origLabel = btn.textContent.trim();
    btn.disabled = true;
    btn.textContent = '...';

    SmCart.addToCart([{ id: variantId, quantity: 1 }])
      .then(function () {
        btn.textContent = '✓ Hinzugefügt';
        triggerCartDrawer();
        setTimeout(function () {
          btn.textContent = origLabel;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function (err) {
        console.error('[SmQuickAdd] failed:', err);
        btn.textContent = 'Fehler';
        setTimeout(function () {
          btn.textContent = origLabel;
          btn.disabled = false;
        }, 1500);
      });
  }

  function triggerCartDrawer() {
    SmCart.openCartDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
